<template>
  <v-card
    color="systemPrimary"
    class="rounded-lg mb-4 d-flex flex-column align-start pa-4"
    id="give-rewards-admin-console"
    width="100%"
    v-if="adminView"
  >
    <div class="d-flex justify-space-between align-center full-width mb-4">
      <v-tooltip top :disabled="!pendingPayment || loading">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="d-flex full-width align-center justify-space-between"
            v-on="on"
            v-bind="attrs"
          >
            <Typography variant="h-5" as="h5" class="word-break white--text text-left">
              Give
            </Typography>
            <div class="d-flex align-center">
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="white"
                width="2"
                size="25"
                class="ml-2"
              ></v-progress-circular>
              <Typography
                variant="h-5"
                as="h5"
                v-else
                class="word-break white--text available to-send"
              >
                <strong>
                  <span v-if="balances.cashBalance > 0">
                    {{ formatCurrency(balances.cashBalance) }}{{ pendingPayment ? "*" : "" }}</span
                  >
                  <span v-if="isOne10PointsEnabled()"
                    ><span class="mx-4">|</span
                    >{{
                      formatCurrency(balances.cashValuePointsBalance, rewardsOverrideAward, true)
                    }}
                  </span>
                </strong>
              </Typography>
            </div>
          </div>
        </template>
        <span> Some pending payments may impact the funds available </span>
      </v-tooltip>
    </div>
    <WalletTileItem
      icon="mdi-party-popper"
      color="brandCyan"
      title="Send recognition"
      @click="loadRecognitionConsole"
    />
    <WalletTileItem
      v-if="showAddFunds"
      icon="mdi-plus-circle-outline"
      color="darkGrey"
      :iconTile="false"
      title="Add funds"
      :dense="true"
      class="mt-4"
      @click="$emit('add-funds')"
    />
  </v-card>
</template>

<script>
// Packages
import { mapState } from "vuex";

// Components
import Typography from "@/components/generic/Typography.vue";
import WalletTileItem from "@/components/wallet/WalletTileItem.vue";

// Services
import BudgetService from "@/services/BudgetService";

// Mixins
import PaymentAdminMixin from "@/mixins/paymentAdminMixin";
import formatCurrencyMixin from "@/mixins/formatCurrency";
import isOne10PointsEnabled from "@/mixins/one10Points/isOne10PointsEnabled";

// Data
import { rewardsOverrideAward } from "@/shared_data/data";

export default {
  name: "GiveRewards",
  components: {
    Typography,
    WalletTileItem,
  },

  props: {
    pendingPayment: Boolean,
    showAddFunds: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      budgetService: null,
      loading: true,
      balances: { cashValuePointsBalance: 0, cashBalance: 0 },
      rewardsOverrideAward,
    };
  },
  mixins: [PaymentAdminMixin, formatCurrencyMixin, isOne10PointsEnabled],
  created() {
    this.budgetService = BudgetService;
    this.getCashValuePointsBudgets();
  },
  computed: {
    ...mapState(["userProfile", "permissions", "roles", "magicLinkToken"]),
  },
  methods: {
    async getCashValuePointsBudgets() {
      if (!this.adminView) return console.log("No admin privileges. Not getting budgets");
      try {
        const response = await this.budgetService.getBudgetsAdminView(
          {
            clientId: this.userProfile.clientId,
          },
          this.magicLinkToken
        );

        // this.funding.budgets = response.result.rows;
        this.balances = response.reduce(
          (acc, curr) => {
            if (curr.pspsNumberId !== null) {
              acc.cashValuePointsBalance += curr.budgetBalance || 0;
            }
            if (curr.awardId == 1) {
              acc.cashBalance += curr.budgetBalance || 0;
            }
            return acc;
          },
          {
            cashValuePointsBalance: 0,
            cashBalance: 0,
          }
        );
      } catch (e) {
        console.log("Error getting budgets ", e);
      } finally {
        this.loading = false;
      }
    },
    loadRecognitionConsole() {
      this.$router.push({
        name: "recognitionwizard",
        query: { previousRoute: this.$route.name },
        params: {
          previousRoute: this.$route.name,
        },
      });
    },
  },
};
</script>

<style scoped></style>
